import TableCell from '@mui/material/TableCell';
import { withStyles } from '@mui/styles';

export const CustomTableCellCheckBox = withStyles(theme => ({
    root: {
        width: '5%'
    }
}))(TableCell);

export const CustomTableCellText = withStyles(theme => ({
    root: {
        width: '25%'
    }
}))(TableCell);

export const CustomTableCellTextNonValid = withStyles(theme => ({
    root: {
        color: 'orangered !important',
        width: '25%'
    }
}))(TableCell);

export const CustomTableCellReportStatus = withStyles(theme => ({
    root: {
        width: '10%'
    }
}))(TableCell);

export const CustomTableCellRimStatus = withStyles(theme => ({
    root: {
        width: '15%'
    }
}))(TableCell);

export const CustomTableCellDownload = withStyles(theme => ({
    root: {
        width: '15%'
    }
}))(TableCell);

export const CustomTableSentDateAndRefresh = withStyles(theme => ({
    root: {
        width: '15%'
    }
}))(TableCell);


